import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IPartnerGroupInfo } from 'legacy/lut/classes/models/partner360/IPartnerGroup'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const fetchPartnerGroupByUID = async (
  groupUID: string,
  forceFetch?: boolean
): Promise<IPartnerGroupInfo | null> => {
  const crud = CrudStore.get(CrudStoreItemPartner360.JBPPartnerGroupInfo, 'fetchPartnerGroupByUID')
  crud.setDefaultFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'UID',
        operator: Operator.EQUAL,
        value: groupUID,
      },
    ],
  })

  const res = await crud.fetch({ force: forceFetch })
  return res?.items?.[0] || null
}
